(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mulligans-category-tabs"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sectionKeys={
    all:"product_list_X8Q7bi",
    hats:"mulligans_cat_hats",
    polos:"mulligans_cat_polos",
    "golf-accessories":"mulligans_cat_golf_accessories",
    outerwear:"mulligans_cat_outerwear"
  };
  function targetNode(key){
    return document.querySelector('[id$="__'+sectionKeys[key]+'"]');
  }
  function applyCategory(root,category){
    if(!sectionKeys[category]||!targetNode(category))return false;
    document.body.dataset.mmCategory=category;
    root.querySelectorAll("[data-mm-tab]").forEach(tab=>{
      const active=tab.dataset.mmTab===category;
      tab.classList.toggle("is-active",active);
      tab.setAttribute("aria-selected",String(active));
      tab.tabIndex=active?0:-1;
    });
    for(const [name] of Object.entries(sectionKeys)){
      const target=targetNode(name);
      const tab=root.querySelector('[data-mm-tab="'+name+'"]');
      if(target){
        target.setAttribute("role","tabpanel");
        if(tab)target.setAttribute("aria-labelledby",tab.id);
        target.setAttribute("aria-hidden",String(name!==category));
      }
    }
    return true;
  }

  const pending=new Map();
  let selection=0;
  async function setCategory(root,category){
    const ticket=++selection;
    const target=targetNode(category);
    if(!target)return false;
    if(target.querySelector("[data-mm-deferred]")){
      const tab=root.querySelector('[data-mm-tab="'+category+'"]');
      root.setAttribute("aria-busy","true");
      try{
        if(!pending.has(category)){
          const url=new URL(window.location.href);
          url.searchParams.delete("sections");
          url.searchParams.set("section_id",target.id.replace(/^shopify-section-/,""));
          pending.set(category,fetch(url,{credentials:"same-origin"}).then(async response=>{
            if(!response.ok)throw new Error("Section request failed");
            const html=await response.text();
            const doc=new DOMParser().parseFromString(html,"text/html");
            const rendered=doc.getElementById(target.id);
            if(!rendered||rendered.querySelector("[data-mm-deferred]")||!rendered.querySelector('[data-testid="product-list"]'))throw new Error("Invalid section");
            target.replaceChildren(...rendered.childNodes);
          }).finally(()=>pending.delete(category)));
        }
        await pending.get(category);
      }catch(error){
        if(ticket===selection&&tab)window.location.assign(tab.href);
        return false;
      }finally{
        if(ticket===selection)root.removeAttribute("aria-busy");
      }
    }else{
      root.removeAttribute("aria-busy");
    }
    if(ticket!==selection)return false;
    return applyCategory(root,category);
  }

  document.addEventListener("click",event=>{
    const tab=event.target.closest("[data-mm-tab]");
    if(!tab)return;
    const root=tab.closest("[data-mm-tabs]");
    if(root&&targetNode(tab.dataset.mmTab)){event.preventDefault();setCategory(root,tab.dataset.mmTab);}
  });
  document.addEventListener("keydown",event=>{
    const tab=event.target.closest("[data-mm-tab]");
    if(!tab)return;
    const root=tab.closest("[data-mm-tabs]");
    if(!root)return;
    const tabs=Array.from(root.querySelectorAll("[data-mm-tab]"));
    const current=tabs.indexOf(tab);
    let selected;
    if(event.key==="ArrowRight")selected=(current+1)%tabs.length;
    else if(event.key==="ArrowLeft")selected=(current-1+tabs.length)%tabs.length;
    else if(event.key==="Home")selected=0;
    else if(event.key==="End")selected=tabs.length-1;
    else return;
    event.preventDefault();
    tabs[selected].focus();
    setCategory(root,tabs[selected].dataset.mmTab);
  });
  document.addEventListener("DOMContentLoaded",()=>{
    document.querySelectorAll("[data-mm-tabs]").forEach(root=>setCategory(root,"all"));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
